export default __webpack_public_path__ + "1a54b36c8a87afea4ed7b3a15f6cc2b8.svg";